import { Suspense, useEffect } from 'react';

import FallBack from '@/components/SuspenseFallBack';
import Layout from '@/layout';
import { MainRoutes } from '@/routes';
import { useAdminStore } from '@/store/admin';

// v0.5 曾把 dealer_admin 强制跳到 /dealers/me，导致登录或点「我的空间」回 /bots
// 时被拦截。v0.9.2 起去掉：dealer_admin 默认进 /bots，通过头像菜单
// 「クーポン管理」入口进自助页。
const MainPage = () => {
  // 自动拉取组织结构和成员数据
  useEffect(() => {
    const { isDataReady, isDataLoading, fetchAllAdminData } = useAdminStore.getState();

    if (!isDataReady && !isDataLoading) {
      console.log('[MainPage] Initializing admin data...');
      fetchAllAdminData().catch((error) => {
        console.error('[MainPage] Failed to initialize admin data:', error);
      });
    }
  }, []);

  return (
    <Layout>
      <Suspense fallback={<FallBack />}>
        <MainRoutes />
      </Suspense>
    </Layout>
  );
};

export default MainPage;
